module.exports = __webpack_public_path__ + "img/newlogo4.4d9f0fe7.png";